export const CARDS_HEADER = 'cards-header'
export const CREATE_CITATIONS_CONTEXT_ID = 'create-citations-context-id'
export const CHECK_PAPER_CONTEXT_ID = 'check-paper-context-id'
